import axios from "axios";
import { Team } from "../models/Team";
import { Standing } from "../models/Standing";
import { TeamMatchStats } from "../models/TeamMatchStats";
import { baseURL } from "../Constants";

const url = `${baseURL}/Team`;

export const fetchTeamByTeamIdAndSeason = async (teamId: string, season: number): Promise<Team | null> => {
    try {
        const response = await axios.get(`${url}/getTeamByTeamIdAndSeason`, {
            params: {
                teamId,
                season
            }
        });
        return response.data;
    }
    catch (error) {
        throw error;
    }
}

export const fetchTeamsByOwner = async (ownerId: string): Promise<Team[]> => {
    try {
        const response = await axios.get(`${url}/getTeamsByOwner`, {
            params: { ownerId }
        });
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const isTeamOwner = async (steamId: string): Promise<boolean> => {
    try {
        const response = await axios.get(`${url}/isTeamOwner`, {
            params: { steamId }
        });
        return response.data;
    } catch (error) {
        throw error;
    }
};


export const fetchTeamsByTeamName = async (teamName: string): Promise<Team[] | undefined> => {
    try {
        const response = await axios.get(`${url}/getTeamsByTeamName/${teamName}`);
        return response.data;
    }
    catch (error) {
        throw error;
    }
}

export const fetchTeamByTeamId = async (teamId: string): Promise<Team> => {
    try {
        const response = await axios.get(`${url}/getTeamByTeamId/${teamId}`);
        return response.data;
    }
    catch (error) {
        throw error;
    }
}

export const fetchUniqueTeamsByTeamName = async (teamName: string): Promise<Team[]> => {
    try {
        const response = await axios.get(`${url}/getUniqueTeamsByName/${teamName}`);
        return response.data;
    }
    catch (error) {
        throw error;
    }
}

export const updateEditTeamPage = async (teamId: string, steamId: string, twitter: string, website: string, coachId: string, season: number): Promise<void> => {
    try {
        await axios.post(`${url}/updateEditTeamPage`, null, {
            params: {
                teamId,
                steamId,
                twitter,
                website,
                coachId,
                season
            }
        });
    } catch (error) {
        throw error;
    }
}
/** The squad behind a team id: its canonical id, and every OverPass id it plays under that season. */
export const fetchTeamRegistrations = async (teamId: string, season?: number): Promise<{ teamId: string; registrationIds: string[] }> => {
    const response = await axios.get(`${url}/registrations/${teamId}`, { params: { season } });
    return response.data;
}

export const fetchSeasonsPlayed = async (teamId: string): Promise<number[]> => {
    try {
        const response = await axios.get(`${url}/getSeasonsPlayed/${teamId}`);
        return response.data;
    }
    catch (error) {
        throw error;
    }
}

export const fetchTeamStanding = async (teamId: string, season: number): Promise<Standing> => {
    try {
        const response = await axios.get(`${url}/getTeamStanding`, {
            params: {
                teamId,
                season
            }
        });
        return response.data;
    }
    catch (error) {
        throw error;
    }
}

export const updateTeamOwner = async (teamId: string, steamId: string, season: number): Promise<boolean> => {
    try {
        const response = await axios.post(`${url}/updateTeamOwner`, null, {
            params: {
                teamId,
                steamId,
                season
            }
        });
        return response.data;
    } catch (error) {
        throw error;
    }
}


export const fetchTeamStats = async (teamId: string, season: number, map?: string): Promise<TeamMatchStats | null> => {
    try {
        const params: any = { teamId, season };
        if (map) params.map = map;
        const response = await axios.get(`${url}/getTeamStats`, { params });
        return response.data;
    } catch (error) {
        throw error;
    }
}

export const fetchTeamPlayedMaps = async (teamId: string, season: number): Promise<string[]> => {
    try {
        const response = await axios.get<TeamMatchStats[]>(`${url}/getTeamMatchStats`, { params: { teamId, season } });
        const maps = Array.from(new Set(response.data.map(s => s.mapName).filter(Boolean)));
        return maps.sort();
    } catch (error) {
        return [];
    }
}

export const fetchTeamByTeamNameAndSeason = async (teamName: string, season: number): Promise<Team | null> => {
    try {
        const params = new URLSearchParams();
        params.append('teamName', teamName);
        params.append('season', season.toString());

        const response = await axios.get(`${url}/getTeamByTeamNameAndSeason`, {
            params
        });
        return response.data;
    }
    catch (error) {
        // Return null if team not found (404) instead of throwing
        if (axios.isAxiosError(error) && error.response?.status === 404) {
            return null;
        }
        throw error;
    }
}